import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import GroupSvg from "../../assets/svg/Group.svg";

import calendar from "../../assets/svg/MonthlyReport.svg";
import LoadIn from "../../assets/svg/LoadIn.svg";
import LoadOut from "../../assets/svg/LoadOut.svg";
import Vehicle from "../../assets/svg/VechicleTypebased.svg";
import DriverBased from "../../assets/svg/DriverBased.svg";
import LocationBased from "../../assets/svg/LocationBased.svg";
import Time from "../../assets/svg/LiveMonitor.svg";
import mawalog from "../../assets/svg/mawaloglogo.svg";
import DatePicker from "react-datepicker";
import { Toast, ToastContainer } from "react-bootstrap";
import { downloadBase64File, exportquickApi, getquickreportApi } from "./report-api";
import { ReactComponent as SlotCloseIcon } from "../../assets/svg/close-1.svg";

const ReportButton = ({ icon, alt, label }) => (
  <button
    className="d-flex align-items-center gap-2 px-4 py-2 w-100"
    style={{
      backgroundColor: "#F5F5F5",
      color: "#172B4D",
      borderRadius: "16px",
      border: "1px solid #E5E5E5",
      maxWidth: "250px",
      height: "48px",
      fontWeight: "500",
      fontSize: "14px",
      marginBottom: "10px",
    }}>
    <img src={icon} alt={alt} style={{ width: "24px", height: "24px" }} />
    {label}
  </button>
);

// List of buttons
// const reportButtons = [
//   { icon: MonthlyReport, alt: "Monthly Report", label: "Monthly Report" },
//   { icon: WeeklyReport, alt: "Weekly Report", label: "Weekly Report" },
//   { icon: LoadIn, alt: "Load In", label: "Load In" },
//   { icon: LoadOut, alt: "Load Out", label: "Load Out" },
//   {
//     icon: VechicleTypebased,
//     alt: "Vehicle Type Based",
//     label: "Vehicle Type Based",
//   },
//   { icon: DriverBased, alt: "Driver Based", label: "Driver Based" },
//   {
//     icon: VechicleNumberBased,
//     alt: "Vehicle Number Based",
//     label: "Vehicle Number Based",
//   },
//   { icon: LocationBased, alt: "Location Based", label: "Location Based" },
//   {
//     icon: OntimeCompleted,
//     alt: "On Time Completed",
//     label: "On Time Completed",
//   },
//   { icon: DelayCompleded, alt: "Delay Completed", label: "Delay Completed" },
//   {
//     icon: OverDelayCompleted,
//     alt: "Over Delay Completed",
//     label: "Over Delay Completed",
//   },
//   { icon: LiveMonitor, alt: "Live Monitor", label: "Live Monitor" },
// ];

const QuickReport = () => {
  const navigate = useNavigate();
  const [reportOptions, setreportOptions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");


  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);

  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const getIconByLabel = (label) => {
    switch (label) {
      case "Monthly Report":
      case "Weekly Report":
        return calendar;
      case "Load In":
        return LoadIn;
      case "Load Out":
        return LoadOut;
      case "Vehicle Type Based":
      case "Vehicle Number Based":
        return Vehicle;
      case "Driver Based":
        return DriverBased;
      case "Location Based":
        return LocationBased;
      case "On Time Completed":
      case "Delay Completed":
      case "Over Delay Completed":
      case "Live Monitor":
        return Time;

      default:
        return calendar;
    }
  };
  const getquickreport = async () => {
    try {
      const response = await getquickreportApi();
      console.log("API response:", response);

      if (response && response.success === true) {
        setreportOptions(response.suggestionlist);
        console.log("successful");
      } else {
        console.warn("Unexpected response or success flag missing:", response);
      }
    } catch (error) {
      console.error("Error in getquickreport:", error);
    }
  };

    //Date Picker
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [formattedFromDate, setFormattedFromDate] = useState("");
  const [formattedToDate, setFormattedToDate] = useState("");

    const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    if (start) {
      const formattedStart = formatDateToYYYYMMDD(start);
      setFormattedFromDate(formattedStart);
    } else {
      setFormattedFromDate("");
    }

    if (end) {
      const formattedEnd = formatDateToYYYYMMDD(end);
      setFormattedToDate(formattedEnd);
    } else {
      setFormattedToDate("");
    }
  };

  const formatDateToYYYYMMDD = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = `${d.getMonth() + 1}`.padStart(2, "0");
    const day = `${d.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleDateClear = () => {
    setStartDate(null);
    setEndDate(null);
    setFormattedFromDate("");
    setFormattedToDate("");
  };

    const handlequickChange = (option) => {
    exportQuickGet(option);
  };

  useEffect(() => {
    getquickreport();
  }, []);

  const exportQuickGet = async (option) => {
    console.log(option.value);
    const response = await exportquickApi(option.value,formattedFromDate,formattedToDate);
    console.log(response);
    setSnackbarMessage(response.data.message);
    setSnackbarStatus(response.data.success);
    handleSnackbarShow();
    if (response.status === 200) {
      console.log("inside sccuess1");
      if (response.data.success === true) {
        console.log("inside sccuess2");
        const base64String = response.data.base64; // Truncated for brevity
        const fileName = response.data.file_name;

        // Convert Base64 to Blob
        downloadBase64File(base64String, fileName);
      }
    }
  };
  return (
    <div className="container my-5" style={{ paddingBottom: "100px" }}>
      {/* Header Section */}
      <div
        className="p-4 d-flex flex-column flex-lg-row align-items-center justify-content-between rounded-5"
        style={{
          background: "linear-gradient(180deg, #FFE9EA 0%, #C4FFED 100%)",
          borderRadius: "24px",
        }}>
        <div className="text-center text-lg-start mb-4 mb-lg-0" style={{ maxWidth: "600px" }}>
          <div className="d-flex justify-content-center justify-content-lg-start bg-white rounded-pill border mb-3 p-1 shadow-sm" style={{ maxWidth: "fit-content" }}>
            <button className="btn btn-danger rounded-pill px-4 py-2 fw-bold">Quick report</button>
            <button className="btn rounded-pill px-4 py-2 text-dark" style={{ backgroundColor: "transparent" }} onClick={() => navigate("/customized")}>
              Customized
            </button>
          </div>
          <h2 className="fw-bold text-dark mb-2" style={{ fontSize: "1.75rem" }}>
            Quick Report Download
          </h2>
          <p className="text-dark" style={{ fontSize: "1rem", color: "#333" }}>
            Generate and save detailed reports with just a single click
            <br />
            <br />
          </p>
        </div>

        <div className="text-center">
          <img src={GroupSvg} alt="Illustration" className="img-fluid" style={{ maxHeight: "220px" }} />
        </div>
      </div>

      {/* Quick Report Box */}
      <div className="bg-white text-center p-4 mt-4" style={{ borderRadius: "24px", maxWidth: "1360px", height: "414px" }}>
        <h2 className="fw-bold fs-1">Quick Report Download</h2>
        <p className="text-muted">Generate and save detailed reports with just a single click</p>
        <button
          className="px-3 py-1 border-0"
          style={{
            backgroundColor: "#FFF0F0",
            borderRadius: "100px",
            fontWeight: "500",
          }}>
          Over 12 types of reports ready-to-download
        </button>

        <h6 className="mt-3 mb-2">Just a single click is enough!</h6>

        {/* Button Grid */}
        <div className="container">
            
                            <div className="mb-2" style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: "flex-end", flexWrap: "wrap" }}>
                              <div style={{ fontWeight: "500", fontSize: "14px", color: "#172b4d" }} >
                                Date range :
                              </div>
                              <div>
                                <DatePicker selected={startDate} onChange={handleDateChange} startDate={startDate} endDate={endDate} selectsRange placeholderText="Select date range" className="form-control rounded-3 custom-datepicker" style={{ backgroundColor: "#F8F8F8", color: "#8790A1", cursor: "pointer" }} />
                              </div>
                              {(startDate || endDate) && (
                                <div style={{ cursor: "pointer" }} onClick={handleDateClear}>
                                  <SlotCloseIcon />
                                </div>
                              )}
                            </div>
                           
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-3" style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
            {/* {reportButtons.map((btn, index) => (
              <div key={index} className="col d-flex justify-content-center">
                <ReportButton {...btn} />
              </div>
            ))} */}
            {reportOptions
              .filter((item) => item.label.toLowerCase().includes(searchTerm?.toLowerCase()))
              .map((item, index) => (
                <div onClick={() => handlequickChange(item)} key={index} style={{ cursor: "pointer", display: "flex", gap: "12px", alignItems: "center", borderRadius: "16px", padding: "12px", border: "0.7px solid #E5E5E5", backgroundColor: "#F5F5F5", width: "calc(25% - 9px)", boxSizing: "border-box" }}>
                  <div>
                    <img src={getIconByLabel(item.label)} style={{ width: "24px" }} />
                  </div>
                  <div style={{ fontWeight: "500", fontSize: "14px", color: "#172B4D" }}>{item.label}</div>
                </div>
              ))}
          </div>
        </div>

        <div style={{ textAlign: "center", marginTop: "80px", fontWeight: "400", fontSize: "12px", color: "#172B4D" }}>
          Powered by{" "}
          <span>
            <img src={mawalog} />
          </span>
        </div>
      </div>
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default QuickReport;
